/**
 * External dependencies
 */
export default class ConnectionWebhooks {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionWebhooks)) {
            return new ConnectionWebhooks(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-connection-webhooks/${this.id}`;
        } else {
            this.path = `/user-site-api/user-connection-webhooks`;
        }
    }

    getConnectionWebhooks() {
        return this.cscom.req.get(this.path);
    }
}
